const messages = {
  title: "Mijn bandenbestellingen",
  desc: "Uw puntensaldo en uw bonus worden 1x per dag bijgewerkt met een vertraging tot 5 dagen in de verkoopdata.<br/>Indien u een vouchercode heeft, kunt u deze code hieronder invoeren en omwisselen naar marketingpunten. De marketingpunten zijn na het toevoegen direct zichtbaar in uw puntensaldo.",
  score: "Puntensaldo",
  regularPoints: "Reguliere punten",
  boosterPoints: "Boosterpunten",
  date: "Datum",
  supplySourceReason: "Distributeur / Bridgestone PLUS",
  article: "Artikel",
  brand: "Merk",
  product: "Product",
  type: "Type",
  inch: "Banden-maat",
  season: "Seizoen",
  amount: "Aantal",
  standardPoints: "Punten",
  boosterProduct: "Boosterproduct",
  boosterSeason: "Boosterseizoen",
  otherActions: "Activiteit",
  totalPoints: "Totaal aantal punten",
  income: "Punten toegevoegd in",
  spending: "Overzicht",
  lastMonth: "huidige status",
  loadMore: "Meer",
  typeFilter: "Filter op distributeur",
  dateFilter: "Filter op datum",
  customer_number: "Klantnr.",
  currentPoints: "Overzicht",
  calculationDate: "Berekeningsdatum",
  positivePoints: "Verdiende punten",
  negativePoints: "Reeds uitgegeven",
  tyresAmount: "Bandenaantal",
  pointsTotal: "Totaal aantal punten",
  currentPointState: "Actueel puntensaldo",
  currentKickbackState: "Actueel bonus",
  pointsFromCurrentYear: "Toevoeging: punten van het huidige jaar ({year})",
  pointsAtRiskOfExpiry: "Te besteden punten tot 31.03.{year}",
  points: "Points",
  noDataFound: "Geen gegevens gevonden",
  seasons: {
    summer: "Zomer",
    winter: "Winter",
    all: "All Season",
  },
  kickbackIncome: "Bonus toegevoegd in",
};

export default {
  messages,
};
